import React from "react";

const Footer = () => (
  <footer className="app-footer">
    © 2021, Sagar Cement. All rights reserved. Powered by Sagarsoft
  </footer>
);

export default Footer;
